<a routerLink="/" class="logo-container">
  <img class="logo" *ngIf="settings.get('branding.logo_light')" [src]="settings.getBaseUrl(true) + settings.get('branding.logo_light')">
  <div class="text-logo" *ngIf="!settings.get('branding.logo_light')">{{settings.get('branding.site_name')}}</div>
</a>
<div class="container-fluid h-100">
  <div class="row h-100 align-items-center justify-content-center">
    <div class="col-10 col-sm-4">
      <p class="heading color--firefile">
        About Us
      </p>
      <br><br>
      <p class="content">
        <span class="color--firefile style--bold">FIREFILE.CC</span> is an <b>online storage</b> and collaboration company
        focused on delivering content
        the world with a complete and user-friendly solution
        for <b>managing</b> their digital content online and on the go.
        <br><br>
        We give users the simplest solution to share data <b>securely</b> on the Internet.
        <br><br>
        <span class="color--firefile style--bold">FIREFILE.CC</span> is the only online storage solution that offers
        unlimited downloads. All downloads are completely
        anonymous. We use <b>end-to-end encryption</b> to guarantee complete <b>security</b> and <b>privacy</b>.
      </p>
    </div>
  </div>
</div>